<template>
  <v-dialog v-model="myValue" persistent max-width="760">
    <v-card>
      <v-card-title class="headline">申请销毁</v-card-title>
      <v-card-text>
        <v-row style="margin-top: 30px" no-gutters>
          <v-col cols="auto" class="text-subtitle-1"
            >我同意将当前项目中所剩余的全部样本，委托给平台（乙方）方完成销毁操作！</v-col
          >
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="darken-1" @click="myValue = false">取消</v-btn>
        <v-btn color="primary darken-1" @click="onRefOk">提交</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { asgLtcHandleSample } from "@/plugins/api";
export default {
  components: {},
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onRefOk() {
      this.$message.confirm("请确认是否销毁", () => {
        this.formData.projectNo = this.myItem.projectcode;
        asgLtcHandleSample([this.formData]).then(({ data }) => {
          if (data) {
            this.$message.success("申请销毁成功。");
            this.myValue = false;
            this.$emit("query");
          }
        });
      });
    },
  },
  data() {
    return {
      formData: {
        projectNo: "",
        type: "2", //余样回收类型；1：回收。2：销毁。
        addressee: "",
        mobile: "",
        address: "",
      },
    };
  },
  computed: {
    myItem() {
      return this.item;
    },
    myValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {},
};
</script>
